var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"orbviz-logo",attrs:{"href":"https://orbviz.com/","target":"_blank"}},[_c('b-img',{attrs:{"fluid":"","src":_vm.OrbVizLogoHorizontal,"alt":"OrbViz logo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }